import React from 'react';
import { useIntl } from 'react-intl';

import { ContainerCard } from '@provider-portal/common/components/ContainerCard/ContainerCard';

export enum MenuSideBarItemType {
  Categories = 'categories',
  Options = 'options',
  Locale = 'locale',
}

interface MenuSideBarItemProps {
  titleIntl: string;
}

export const MenuSideBarSection: React.FC<MenuSideBarItemProps> = ({ titleIntl, children }) => {
  const intl = useIntl();

  return <ContainerCard title={intl.formatMessage({ id: titleIntl })}>{children}</ContainerCard>;
};
